export const hasUtmParams = (routeParams) => {
  return (
    routeParams !== undefined &&
    Object.keys(routeParams).some((k) => k.startsWith('utm'))
  )
}

export const getUtmParams = (routeParams) => {
  return Object.keys(routeParams)
    .filter((k) => k.startsWith('utm'))
    .reduce((prev, cur) => ({ ...prev, [cur]: routeParams[cur] }), {})
}
